<script>
  'use strict'

  let tileSize = 64;

  // -------------------------------------------------
	$: tileSize, updateTileSize('--grid-tile-size', tileSize);

  // -------------------------------------------------
  function updateTileSize(cssCustomPropertyKey, value) {
    document.documentElement.style.setProperty(cssCustomPropertyKey, `${value}px`);
  }
</script>

<div>
  <label for="tileSize">Grid Tile Size</label>
  <input type="number" name="tileSize" id="tileSize" min="0" bind:value={tileSize} tabindex=4>
</div>